import React, { PureComponent } from 'react';
import { Checkbox, Row, Col } from 'antd';
import { language } from '../../../language';
import { ColorPicker } from '../../tools';
export class ShowContent extends PureComponent<any> {
    select = (showContent) => {
        const { onChange } = this.props;
        onChange(showContent);
    };

    render() {
        const { value, getFieldDecorator, hideMarketPrice } = this.props;
        return (
            <Checkbox.Group style={{ width: '100%' }} value={value} onChange={this.select}>
                <Row className="show-content">
                    <Col span={24}>
                        <Checkbox value="buy">
                            {language.getText('components.Products.buy')}
                        </Checkbox>
                    </Col>
                    <Col span={24}>
                        <Checkbox value="name">
                            {language.getText('components.Products.name')}
                        </Checkbox>
                    </Col>
                    <Col className="show-content-item" span={24}>
                        <Checkbox value="price">
                            {language.getText('components.Products.price')}
                        </Checkbox>
                        {getFieldDecorator('showContentColor.price')(<ColorPicker />)}
                    </Col>
                    {!hideMarketPrice && (
                        <Col className="show-content-item" span={24}>
                            <Checkbox value="marketPrice">
                                {language.getText('components.Products.marketPrice')}
                            </Checkbox>
                            {getFieldDecorator('showContentColor.marketPrice')(<ColorPicker />)}
                        </Col>
                    )}
                </Row>
            </Checkbox.Group>
        );
    }
}
